import { useEffect } from 'react';
import { useUser, useOrganization } from '@clerk/clerk-react';
import { updateUserInfoForCrashReporting } from '../_rum';

/**
 * Custom hook to update user information for error reporting
 * This hook should be used in a component that has access to the Clerk user
 */
export function useErrorReporting() {
  const { user, isLoaded: isUserLoaded } = useUser();
  const { organization, isLoaded: isOrgLoaded } = useOrganization();

  // Update user information whenever the user or organization changes
  useEffect(() => {
    if (isUserLoaded && user) {
      const userInfo = {
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
      };

      if (isOrgLoaded && organization) {
        userInfo.organizationId = organization.id;
      }
      updateUserInfoForCrashReporting(userInfo);
    }
  }, [user, organization, isUserLoaded, isOrgLoaded]);

  return null; // This hook doesn't return anything
}
